<template>
	<div>
		<core-layout-headline-with-tabs :tabs="[]">
			{{ $t("case") }}
		</core-layout-headline-with-tabs>

		<case-explorer-with-layout>
			<!-- Case View -->
			<div
				slot="case"
				slot-scope="{ setViewId }"
				class="md-p8 p4 max3 margin-center"
			>
				<div class="flex wrap">
					<!-- Left -->
					<div class="md-6 xs-12 p2">
						<proposal-list
							@proposal:clicked="
								setViewId({ viewId: 'proposal', proposalId: $event })
							"
						/>
						<case-overview-holder class="mt4" />
						<case-overview-other-holders class="mt4" />
						<case-overview-insureds class="mt4" />
						<case-overview-facts class="mt10" />
						<case-payment-infos class="mt10" />
						<case-beneficiaries class="mt10" />
					</div>

					<!-- Right -->
					<div class="md-6 xs-12 p2">
						<case-overview-credentials />
					</div>
				</div>
			</div>

			<!-- Proposal View -->
			<div
				slot="proposal"
				slot-scope="{ setViewId }"
				class="md-p8 p4 max2 margin-center"
			>
				<proposal-detail
					@offer:click="setViewId({ viewId: 'offer', offerId: $event })"
					@go:back="setViewId({ viewId: 'case' })"
				>
					<asia-vhis-proposal-actions class="mt6" />
				</proposal-detail>
			</div>

			<!-- Offer View -->
			<div
				slot="offer"
				slot-scope="{ setViewId }"
				class="md-p8 p4 max2 margin-center"
			>
				<offer-detail @go:back="setViewId({ viewId: 'proposal' })" />
			</div>
		</case-explorer-with-layout>
	</div>
</template>

<script>
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs.vue"
import CaseExplorerWithLayout from "../CaseExplorer/CaseExplorerWithLayout.vue"
import ProposalList from "../CaseExplorer/ProposalList"
import ProposalDetail from "../CaseExplorer/ProposalDetail"
import OfferDetail from "../CaseExplorer/OfferDetail"
import CaseOverviewHolder from "../CaseExplorer/CaseOverviewHolder"
import CaseOverviewOtherHolders from "../CaseExplorer/CaseOverviewOtherHolders"
import CasePaymentInfos from "../CaseExplorer/CasePaymentInfos"
import CaseOverviewInsureds from "../CaseExplorer/CaseOverviewInsureds"
import CaseOverviewFacts from "../CaseExplorer/CaseOverviewFacts"
import CaseOverviewCredentials from "../CaseExplorer/CaseOverviewCredentials"
import CaseBeneficiaries from "../CaseExplorer/CaseBeneficiaries"
import AsiaVhisProposalActions from "./AsiaVhisProposalActions"

export default {
	components: {
		CoreLayoutHeadlineWithTabs,
		CaseExplorerWithLayout,
		ProposalList,
		ProposalDetail,
		OfferDetail,
		CaseOverviewHolder,
		CaseOverviewOtherHolders,
		CaseBeneficiaries,
		CaseOverviewInsureds,
		CaseOverviewFacts,
		CasePaymentInfos,
		CaseOverviewCredentials,
		AsiaVhisProposalActions
	}
}
</script>
